import PubSub from "underpub-js";

var BannerButton = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-BannerButton',
	};

	$.extend(true, this.options, options);

};

BannerButton.prototype.init = function() {

	var self = this;

	this.options.$el.find('.banner-button_close-button').on('click', function(e) {
		e.preventDefault();
		self.options.$el.hide();
	});

};

export default BannerButton;
